import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

interface EventDetailsStepProps {
  title: string;
  date: string;
  venue: string;
  onChange: (field: 'title' | 'date' | 'venue', value: string) => void;
}

const EventDetailsStep: React.FC<EventDetailsStepProps> = ({ title, date, venue, onChange }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
      <Typography
        variant="h6"
        sx={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 600, mb: 1 }}
      >
        Tell us about your wedding
      </Typography>
      <TextField
        label="Wedding Title"
        fullWidth
        required
        value={title}
        onChange={(e) => onChange('title', e.target.value)}
        placeholder="e.g. Sarah & John's Wedding"
      />
      <TextField
        label="Wedding Date"
        type="date"
        fullWidth
        value={date}
        onChange={(e) => onChange('date', e.target.value)}
        slotProps={{ inputLabel: { shrink: true } }}
      />
      <TextField
        label="Venue"
        fullWidth
        value={venue}
        onChange={(e) => onChange('venue', e.target.value)}
        placeholder="e.g. The Grand Ballroom"
      />
    </Box>
  );
};

export default EventDetailsStep;
